import { omit } from 'lodash';

import { Loader } from '@hivebrite/design-system/Loader';

import { TopicProvider } from 'hb-react/backoffice/contexts/TopicContext';
import CombineProvider from 'hb-react/shared/components/CombineProvider';
import App from 'hb-react/shared/providers/App';
import QueryClientProvider from 'hb-react/shared/providers/QueryClient';
import { useLaunchDarklyProviderConfig } from 'hb-react/shared/utils/launchDarkly';

const Providers = ({ network, topic, showLoader, ...props }) => {
  /* This will strip any custom colors from being used on the BO. */
  const _network = omit(network, ['colors', 'theming']);
  const _props = omit(props, ['colors']);

  const { status, providerConfig } = useLaunchDarklyProviderConfig();

  const LoaderBlock = showLoader ? <Loader /> : null;

  const context = {
    network: _network,
    theme: 'bo',
    ..._props,
  };

  // Launchdarkly flags fetch is required to render the app
  return status === 'success' ? (
    // Use CombineProvider to naturally remove LD Provider in local when providerConfig is null
    <CombineProvider
      providers={[
        providerConfig,
        {
          provider: TopicProvider,
          topic,
        },
      ]}
    >
      <App {...context} />
    </CombineProvider>
  ) : (
    <>{LoaderBlock}</>
  );
};

const BackOfficeApp = (props) => (
  <QueryClientProvider>
    <Providers {...props} />
  </QueryClientProvider>
);

export default BackOfficeApp;
